import { useEffect } from 'react';

import { useIsCurrentUserEmailVerified } from '~/swr-hooks/account/useIsCurrentUserEmailVerified';
import { scheduleClearSharedAuthResumeState } from '~/utils/auth/SessionHelpers';

export const useScheduleClearAuthResumeState = () => {
  const { isFetched, userEmailIsVerified } = useIsCurrentUserEmailVerified();

  useEffect(() => {
    if (!isFetched || userEmailIsVerified !== true) {
      return;
    }

    scheduleClearSharedAuthResumeState();
  }, [isFetched, userEmailIsVerified]);
};
